function Footer(){
    return(
        <footer className="foot">
            <p>Building modern web experiences with React.</p>
            <small>© 2026 Reactor. All Rights Reserved.</small>
        </footer>
    );
}

export default Footer;